import gql from 'graphql-tag';

const GET_NEXXEN_SEGMENTS = gql`
  query getNexxenSegments($advertiserId: ID, $marketId: String, $segmentUsage: String, $offset: Int, $limit: Int) {
    nexxenSegments(advertiserId: $advertiserId, marketId: $marketId, segmentUsage: $segmentUsage, offset: $offset, limit: $limit) {
      queryTotal
      data {
        id
        name
        description
        status
        dataProvider
        segmentUsage
        cpmCost
        percentCost
      }
    }
  }
`;

export default GET_NEXXEN_SEGMENTS;
